import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import logo from './assets/logofinal.png';

const HeaderRunwayStyle = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 30); // seuil de scroll
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed-top transition-all ${
        scrolled ? 'bg-dark bg-opacity-90 shadow-sm' : 'bg-transparent'
      } py-3`}
      style={{ zIndex: 1000, transition: 'background-color 0.3s ease' }}
    >
      <div className="container d-flex justify-content-between align-items-center">
        <Link to="/" className="text-white text-decoration-none fs-4 fw-bold d-flex align-items-center">
          <img src={logo} alt="Logo" style={{ height: '100px', width: '150px', objectFit: 'contain' }} />

        </Link>

        <nav className="d-none d-md-flex gap-4 text-white text-uppercase fw-semibold fs-6">
          <Link to="/research" className="text-white text-decoration-none">Research</Link>
          <Link to="/product" className="text-white text-decoration-none">Product</Link>
          <Link to="/studios" className="text-white text-decoration-none">Studios</Link>
          <Link to="/company" className="text-white text-decoration-none">Company</Link>
        </nav>

        <Link to="/wizard" className="btn btn-light rounded-pill px-4 fw-bold">
          Get Started
        </Link>
      </div>
    </header>
  );
};

export default HeaderRunwayStyle;
